import React from 'react';
import { ArrowRight } from 'lucide-react';

// A NOTICE — something waiting on you, at the top of a page ("2 people are
// asking to be friends"): what it is, who, and one clear button that says what
// it does. A thin sheet on the canvas with a bar of the warning hue at its
// left; never a whole row that is secretly a button.
export default function Notice({ title, sub, action, tone = 'warn' }) {
    return (
        <section className={`nx-notice is-${tone}`} aria-label={title}>
            <div className="nx-notice__text">
                <p className="nx-notice__title">{title}</p>
                {sub && <p className="nx-notice__sub">{sub}</p>}
            </div>
            {action && (
                <button type="button" className="nucleus-verb nx-notice__act" onClick={action.run}>
                    <span className="nucleus-verb__word">{action.label}</span>
                    <span className="nucleus-verb__glyph" aria-hidden="true"><ArrowRight /></span>
                </button>
            )}
        </section>
    );
}
